import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import Modal from 'embed/components/Modal'
import { useTheme } from 'embed/hooks'
import { getContrastingColor } from 'embed/utils'

const FilterIcon = require('./filter.svg')
const styles = require('./styles')

export interface FilterModalProps {
  className?: string
}

const FilterModal: React.FC<FilterModalProps> = ({ children, className }) => {
  const [modalVisible, setModalVisible] = React.useState(false)
  const toggleModalVisible = React.useCallback(() => setModalVisible(!modalVisible), [modalVisible])
  const { borderRadiusSmall, colorPrimary, colorTextPrimary, fontFamilyPrimary } = useTheme()

  return (
    <>
      <button
        data-test-id="filter_button"
        className={classnames(
          styles.filterButton,
          css`
            background-color: ${colorPrimary};
            border-radius: ${borderRadiusSmall};
            font-family: ${fontFamilyPrimary};
            color: ${getContrastingColor(colorPrimary, { black: colorTextPrimary })};
          `,
          className,
        )}
        onClick={toggleModalVisible}
      >
        <FilterIcon
          className={classnames(
            styles.icon,
            css`
              path {
                fill: ${getContrastingColor(colorPrimary, { black: colorTextPrimary })};
              }
            `,
          )}
        />{' '}
        Filter
      </button>
      {modalVisible && (
        <Modal
          className={styles.modal}
          overlayClassName={styles.modalOverlay}
          onDismiss={toggleModalVisible}
          showHeader={true}
        >
          {children}
        </Modal>
      )}
    </>
  )
}

export default FilterModal
